import React from 'react';

const Donate: React.FC = () => {
  return (
    <div className="section-padding">
      <div className="container">
        <div className="section-title">
          <h1>Support Our Mission</h1>
          <p>Help us maintain and improve ImanVerse for the global Muslim community</p>
        </div>

        {/* Add back button to Donate.tsx */}
<div style={{ marginBottom: '32px' }}>
  <button
    onClick={() => window.history.back()}
    style={{
      background: 'none',
      border: 'none',
      color: 'var(--accent-primary)',
      cursor: 'pointer',
      fontSize: '16px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    }}
  >
    ← Back
  </button>
</div>

        <div className="card" style={{ maxWidth: '800px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <div style={{ fontSize: '48px', marginBottom: '20px', opacity: '0.9' }}>🤲</div>
            <h2 style={{ 
              fontSize: '1.75rem', 
              fontWeight: '600', 
              marginBottom: '16px',
              color: 'var(--text-primary)'
            }}>
              Assalamu Alaikum wa Rahmatullahi wa Barakatuh
            </h2>
          </div>

          <div style={{
            color: 'var(--text-secondary)',
            fontSize: '16px',
            lineHeight: '1.7',
            marginBottom: '32px'
          }}>
            <p style={{ marginBottom: '20px' }}>
              I manage and maintain ImanVerse alone. To keep this resource available and to improve it — 
              adding accurate translations, audio recitations, and accessibility updates — I humbly request voluntary donations.
            </p>
            <p style={{ marginBottom: '20px' }}>
              This is purely voluntary; donate any amount you are comfortable with. Your contribution is a form of 
              <strong> Sadaqah-e-Jariyah</strong> (ongoing charity), and will help keep ImanVerse running and growing, inshaAllah.
            </p>
            <p>
              <strong>JazakAllahu Khairan</strong> for your support and dua.
            </p>
          </div>

          <div style={{
            backgroundColor: 'var(--bg-secondary)',
            borderRadius: '12px',
            padding: '24px',
            marginBottom: '32px',
            border: `1px solid var(--border)`
          }}>
            <h3 style={{ 
              fontSize: '1.25rem', 
              fontWeight: '600', 
              marginBottom: '16px',
              color: 'var(--text-primary)'
            }}>
              Contact & Support
            </h3>
            <p style={{ 
              color: 'var(--text-secondary)',
              marginBottom: '12px'
            }}>
              <strong>Email:</strong> md.shafee05s@gmail.com
            </p>
            <p style={{ color: 'var(--text-secondary)' }}>
              For any questions about donations or to discuss partnership opportunities.
            </p>
          </div>

          <div style={{ textAlign: 'center' }}>
            <a 
              href="https://razorpay.me/@mohammadshafeeurrahaman" 
              className="btn-primary"
              style={{ 
                textDecoration: 'none',
                display: 'inline-block',
                fontSize: '16px',
                padding: '14px 32px'
              }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Donate via Razorpay
            </a>
            <p style={{ 
              color: 'var(--text-secondary)', 
              fontSize: '14px', 
              marginTop: '16px',
              opacity: '0.8'
            }}>
              Secure payment processing via Razorpay
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Donate;